export default [
	//API调用日志(运维管理)
	{
		path: 'api-call-log',
		name: 'm_maintenance_api_call_log',
		props: route => route.params,
		component: () => import('@/pages/maintenance/api_call_log_list')
	}, {  // MQ错误消息
		path: 'mq_error_log',
		name: 'm_mq_error_log',
		props: route => route.params,
		component: () => import('@/pages/system/mq_error_log_list')
	}
];
